import React from "react";

export const SEVERITY_STYLES = {
  critical: "border-primary text-primary",
  high: "border-accent text-[hsl(42,55%,40%)]",
  medium: "border-secondary text-secondary",
  low: "border-muted-foreground text-muted-foreground",
};

export function SeverityBadge({ severity }) {
  return (
    <span className={`font-mono text-[10px] uppercase tracking-wide px-1.5 py-0.5 border bg-card ${SEVERITY_STYLES[severity] || SEVERITY_STYLES.low}`}>
      {severity}
    </span>
  );
}

export function CategoryTag({ category }) {
  return (
    <span className="font-mono text-[11px] text-secondary border border-secondary/40 bg-secondary/5 px-1.5 py-0.5">
      {category}
    </span>
  );
}

export function StatCard({ icon: Icon, label, value, sub, accent }) {
  return (
    <div className="bg-card border border-border p-5">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{label}</span>
        {Icon && <Icon size={16} className={accent ? "text-primary" : "text-muted-foreground"} />}
      </div>
      <div className="font-display font-black tracking-tighter text-3xl mt-3">{value}</div>
      {sub && <div className="font-mono text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}
